
import { Component, Vue, Prop } from 'vue-property-decorator';
import TermsOfServiceApp from '@/terms_of_service/App.vue';

@Component({
  components: {
    TermsOfServiceApp
  }
})
export default class Parts extends Vue {
  @Prop({ type: Number, required: true })
  public version!: number;
}
